import React from "react";
import MasterLayout from "../../masterLayout/MasterLayout";
import Breadcrumb from "../../components/Breadcrumb";
import EditAreaLayer from "../../components/locations/EditAreaLayer";


const EditAreaPage = () => {
  return (
    <>
      {/* MasterLayout */}
      <MasterLayout>

        {/* Breadcrumb */}
        <Breadcrumb title="Edit Area" />

        {/* AddUserLayer */}
        <EditAreaLayer />


      </MasterLayout>
    </>
  );
};

export default EditAreaPage;
